/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'TablaEtiquetaItems.EtiquetaItems': 'Label Items',
    'TablaEtiquetaItems.DescripcionItem': 'Product',
    'TablaEtiquetaItems.CodigoEmpresaItem': 'Company code',
    'TablaEtiquetaItems.Unidad': 'Unit',
    'TablaEtiquetaItems.Clasificacion': 'Classification',
};
